<template>
  <div>
    <div
      class="tabs"
      :class="{
        'is-centered': centered,
        'is-boxed': boxed,
        'is-toggle': toggle,
        'is-toggle-rounded': rounded
      }"
    >
      <ul>
        <li
          v-for="(tab, key) in tabs"
          :key="key"
          @click="$emit('input', key)"
          :class="{ 'is-active': value === key }"
        >
          <a>
            <icon :name="tab.icon" v-if="tab.icon" />
            {{ tab.text }}
          </a>
        </li>
      </ul>
    </div>

    <div>
      <slot :name="value" />
    </div>
  </div>
</template>

<script>
import { Icon } from "%helpers";

export default {
  name: "tabs",

  components: {
    Icon
  },

  props: {
    tabs: Object,
    value: String,
    centered: Boolean,
    boxed: Boolean,
    toggle: Boolean,
    rounded: Boolean
  }
};
</script>

<style></style>
